var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicro = function SvgMicro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 7.65V3.35C4.5 1.5 6.05 0 8 0C9.95 0 11.5 1.5 11.5 3.35V7.65C11.5 9.5 9.95 11 8 11C6.05 11 4.5 9.5 4.5 7.65ZM7 13.9255V15C7 15.55 7.45 16 8 16C8.55 16 9 15.55 9 15V13.9255C12.1222 13.4555 14.5 10.8192 14.5 7.65V7C14.5 6.45 14.05 6 13.5 6C12.95 6 12.5 6.45 12.5 7V7.65C12.5 10.05 10.5 12 8 12C5.5 12 3.5 10.05 3.5 7.65V7C3.5 6.45 3.05 6 2.5 6C1.95 6 1.5 6.45 1.5 7V7.65C1.5 10.8192 3.87779 13.4555 7 13.9255Z"
  })));
};
export default SvgMicro;